<markant-dialog
  class="dialog"
  [open]="true"
  [headTitle]="
    'catalog.detail.cartridgeVariants.demo.completeProfile' | transloco
  "
  (close)="close.emit()"
>
  <section class="dialog-content">
    <p>
      {{ 'catalog.detail.cartridgeVariants.demo.dialog.content' | transloco }}
    </p>
  </section>

  <section slot="markant-dialog-footer">
    <markant-button
      data-cy="complete-profile-dialog-cancel-button"
      colorScheme="primary"
      variant="clear"
      label="Cancel"
      data-markant-dialog-action="cancel"
    >
      <span>{{ 'common.cancel' | transloco }}</span>
    </markant-button>

    <markant-button
      data-cy="complete-profile-dialog-add-information-button"
      colorScheme="primary"
      data-markant-dialog-action="completeProfile"
      label="Add further information"
      (click)="completeProfile.emit()"
      (keydown.enter)="completeProfile.emit()"
    >
      {{ 'catalog.detail.cartridgeVariants.demo.dialog.action' | transloco }}
    </markant-button>
  </section>
</markant-dialog>
